import React from 'react';
export function ChalkboardPattern({
  className = 'text-white opacity-5'
}: {
  className?: string;
}) {
  return <svg className={`absolute inset-0 w-full h-full pointer-events-none ${className}`} xmlns="http://www.w3.org/2000/svg" data-id="element-50">
      <defs data-id="element-51">
        <pattern id="rugby-tactics" width="120" height="120" patternUnits="userSpaceOnUse" data-id="element-52">
          {/* Field lines */}
          <path d="M0 60 L120 60" stroke="currentColor" strokeWidth="1" strokeDasharray="4 4" fill="none" data-id="element-53" />
          <path d="M60 0 L60 120" stroke="currentColor" strokeWidth="0.5" fill="none" data-id="element-54" />
          {/* X and O */}
          <circle cx="30" cy="30" r="4" stroke="currentColor" strokeWidth="1.5" fill="none" data-id="element-55" />
          <path d="M85 25 L95 35 M95 25 L85 35" stroke="currentColor" strokeWidth="1.5" fill="none" data-id="element-56" />
          {/* Arrow */}
          <path d="M30 34 Q 45 50 60 40" stroke="currentColor" strokeWidth="1" strokeDasharray="2 2" fill="none" data-id="element-57" />
          <path d="M55 38 L60 40 L58 45" stroke="currentColor" strokeWidth="1" fill="none" data-id="element-58" />
          {/* 3m attack line text hint */}
          <text x="5" y="55" fill="currentColor" fontSize="8" fontFamily="sans-serif" opacity="0.7" fontWeight="bold" data-id="element-59">
            3m
          </text>
        </pattern>
      </defs>
      <rect width="100%" height="100%" fill="url(#rugby-tactics)" data-id="element-60" />
    </svg>;
}